import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-table-paginator',
  templateUrl: './table-paginator.component.html',
  styleUrls: ['./table-paginator.component.scss']
})
export class TablePaginatorComponent {

  @Input()
  loading: boolean = false;

  @Input()
  currentPage: number = 1;

  @Input()
  pageAmount: number = 1;

  @Output()
  pageEmitter = new EventEmitter()

  pages: number[] = [];
  pagesToShow: number[] = [];

  checkAmout = 1;
  maxVisiblePages = 3;

  shouldShowLeftEllipsis: boolean = false;
  shouldShowRightEllipsis: boolean = false;

  ngOnChanges(changes: SimpleChanges) {
    this.checkAmout = this.pageAmount === 0 ? 1 : this.pageAmount

    if (changes['pageAmount'] && changes['pageAmount'].currentValue) {
      this.pages = Array.from({ length: changes['pageAmount'].currentValue }, (_, i) => i + 1);
    }
    if (this.pages.length == 0) {
      this.pages = [1]
    }
    this.updatePagination();
  }


  prevPage() {
    if (this.currentPage != 1) {
      this.pageEmitter.emit(this.currentPage - 1)
    }
  }

  nextPage() {
    if (this.currentPage < this.pageAmount) {
      this.pageEmitter.emit(this.currentPage + 1)
    }
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.checkAmout) {
      this.currentPage = page;
      this.pageEmitter.emit(this.currentPage)
      this.updatePagination();
    }
  }



  updatePagination(): void {
    const totalVisiblePages = this.maxVisiblePages;
    const halfRange = Math.floor(totalVisiblePages / 2);

    if (this.checkAmout <= 7) {
      this.pagesToShow = this.pages;
      this.shouldShowLeftEllipsis = false;
      this.shouldShowRightEllipsis = false;
      return;
    }

    this.shouldShowLeftEllipsis = this.currentPage > halfRange + 2;
    this.shouldShowRightEllipsis = this.currentPage < this.checkAmout - halfRange - 1;

    let start = Math.max(2, this.currentPage - halfRange);
    let end = Math.min(this.checkAmout - 1, this.currentPage + halfRange);

    if (this.currentPage <= halfRange + 1) {
      end = Math.min(this.checkAmout - 1, totalVisiblePages + 1);
    }
    if (this.currentPage >= this.checkAmout - halfRange) {
      start = Math.max(2, this.checkAmout - totalVisiblePages);
    }

    this.pagesToShow = [];
    for (let i = start; i <= end; i++) {
      this.pagesToShow.push(i);
    }
  }
}
